import React from 'react';
import { Typography, Box } from '@mui/material';

const Blog: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" component="h1" gutterBottom>
        自治体情報ブログ
      </Typography>
      <Typography>ブログページ（開発中）</Typography>
    </Box>
  );
};

export default Blog;
